import { useEffect, useRef } from 'react';

export const useEscapeClose = (onEscapeClose: () => void) => {
    const onEscapeCloseRef = useRef(onEscapeClose);
    onEscapeCloseRef.current = onEscapeClose;

    useEffect(() => {
        const handleEscKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onEscapeCloseRef.current();
            }
        };

        window.addEventListener('keydown', handleEscKey);

        return () => {
            window.removeEventListener('keydown', handleEscKey);
        };
    }, []);
};
